import React, { useState } from 'react';
import Logo from '../../img/logo.png'
import { useNavigate } from "react-router-dom";
const Header = ({ logIn, setLogIn, render, setRender, activeMenuItem }) => {
  const navigate = useNavigate()

  const handleRefreshClick = () => {
    window.location.reload();
  };

  const handleLogout = () => {
    localStorage.removeItem('userEcommerce');
    localStorage.removeItem('expirationDateEcommerce');
    setRender(!render)
  };
  const [orderOpen, setOrderOpen] = useState(false)
  const [active, setactive] = useState("")

  return (
    <>
      <div className={`offcanvas-menu-overlay ${active}`} onClick={()=>{setactive(""); setOrderOpen(false)}}></div>
      
      <div className={`offcanvas-menu-wrapper ${active}`}>
        <div className="offcanvas__close" onClick={()=>{setactive(""); setOrderOpen(false)}}>+</div>
        <ul className="offcanvas__widget" style={{ visibility: 'hidden' }}>
          <li><span className="icon_search search-switch"></span></li>
          <li><a ><span className="icon_heart_alt"></span>
            <div className="tip">2</div>
          </a></li>
          <li><a ><span className="icon_bag_alt"></span>
            <div className="tip">2</div>
          </a></li>
        </ul>
        <div className="offcanvas__logo">
          <a href="./"><img src={Logo} alt="" /></a>
        </div>
        <div id="mobile-menu-wrap">
          <div className="slicknav_menu">
            <nav className="slicknav_nav " aria-hidden="true" role="menu" style={{ display: "none" }}>
              <ul>
                <li className={activeMenuItem === 'Accueil' ? 'active' : ''}>
                  <a onClick={() => { navigate("/"); setactive("")}} style={{ cursor: 'pointer' }}>Accueil</a>
                </li>
                {logIn && <>
                  <li >
                    <a onClick={() => { navigate("/ajouter-produit"); setactive("")}} style={{ cursor: 'pointer' }}>Ajouter nouveau</a>
                  </li>
                  <li >
                    <a onClick={() => { navigate("/mise-à-jour"); setactive("") }} style={{ cursor: 'pointer' }}>Mise à jour</a>
                  </li>

                  <li className="slicknav_parent slicknav_collapsed">
                    <a style={{ cursor: 'pointer' }} onClick={()=> setOrderOpen(!orderOpen)}> Commandes {!orderOpen ? <span >►</span>: <span >▼</span> }</a>

                    {orderOpen && <ul className="dropdown">
                      <li><a onClick={() => { navigate("/commandes/en-attente"); setactive(""); setOrderOpen(!orderOpen) }} style={{ cursor: 'pointer' }}>En attente</a></li>

                      <li><a onClick={() => { navigate("/commandes/confirmées"); setactive(""); setOrderOpen(!orderOpen) }} style={{ cursor: 'pointer' }}>Confirmées</a></li>
                    </ul>}
                  </li>
                </>}
              </ul>
            </nav>
          </div>
        </div>
        <div className="offcanvas__auth">
          {!logIn && <a onClick={() => { navigate("/login"); setactive("") }} style={{ cursor: 'pointer' }}>Login</a>}
          {logIn && <a onClick={() => { navigate("/"); setLogIn(false); handleLogout(); setactive("") }} style={{ cursor: 'pointer' }}>Log out</a>}
        </div>
      </div>
      <header className="header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-lg-2">
              <div className="header__logo">
                <a href="./"><img src={Logo} alt="" /></a>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7">
              <nav className="header__menu">
                <ul>
                  <li className={activeMenuItem === 'Accueil' ? 'active' : ''}>
                    <a onClick={() => { navigate("/"); handleRefreshClick() }} style={{ cursor: 'pointer' }}>Accueil</a>
                  </li>
                  {logIn && <>
                    <li className={activeMenuItem === 'Ajouter nouveau' ? 'active' : ''}>
                      <a onClick={() => { navigate("/ajouter-produit") }} style={{ cursor: 'pointer' }}>Ajouter nouveau</a>
                    </li>
                    <li className={activeMenuItem === 'Mise à jour' ? 'active' : ''}>
                      <a onClick={() => { navigate("/mise-à-jour") }} style={{ cursor: 'pointer' }}>Mise à jour</a>
                    </li>

                    <li className={activeMenuItem === 'En attente' || activeMenuItem === 'Confirmées' ? 'active' : ''}>
                      <a style={{ cursor: 'pointer' }}>Commandes</a>
                      <ul className="dropdown">
                        <li><a onClick={() => { navigate("/commandes/en-attente") }} style={{ cursor: 'pointer' }}>En attente</a></li>

                        <li><a onClick={() => { navigate("/commandes/confirmées") }} style={{ cursor: 'pointer' }}>Confirmées</a></li>
                      </ul>
                    </li>
                  </>}
                </ul>
              </nav>
            </div>
            <div className="col-lg-3">
              <div className="header__right">
                <div className="header__right__auth">
                  {!logIn && <a onClick={() => { navigate("/login") }} style={{ cursor: 'pointer' }}>Login</a>}
                  {logIn && <a onClick={() => { navigate("/"); setLogIn(false); handleLogout() }} style={{ cursor: 'pointer' }}>Log out</a>}
                </div>

              </div>
            </div>
          </div>
          <div className="canvas__open" onClick={()=>setactive("active")}>
            <i className="fa fa-bars"></i>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
